import ApiBase from '../ApiBase';

/**
 * @classdesc Holiday booking api stuff
 */
class Holiday extends ApiBase {
  /**
   * @method createHoliday
   * @param {object} data
   * @return {Promise<*>}
   */
  createHoliday = (data) => this.post('holidays', data, 'create', 201, {
      headers: {
          "Content-Type": undefined
      }
  });

  /**
   * @method fetch
   * @param {number} page
   * @param {string} userId
   * @param {object} params
   * @param {string} includes
   * @return {Promise<*>}
   */
  fetch = (page, userId, params, includes) => this.get('holidays', {
      page,
      per_page: 8,
      user_id: userId,
      ...params,
      includes
  });

  /**
   * @method update
   * @param {string} id
   * @param {object} data
   * @param {string} event
   * @return {Promise<boolean|{status: number}>}
   */
  update = (id, data, event = 'update') => this.patch(`holidays/${id}`, data, event);

  /**
   * @method cancelMyHoliday
   * @param {string} id
   * @param {string} notes
   * @return {Promise<boolean|{status: number}>}
   */
  cancelHoliday = (id, notes) => this.update(id, {
      notes,
      status: 'cancelled',
  }, 'cancel');

  /**
   * @render fetchHolidayApprovals
   * @param {number} page
   * @param {object} data
   * @return {Promise<*>}
   */
  fetchHolidayApprovals = (page, data) => this.get('holidays/approvals', {
      page,
      ...data
  });

  /**
   * @method approveHoliday
   * @param {string} id
   * @return {Promise<*>}
   */
  approveHoliday = (id) => this.update(id, {
        status: 'approved',
    }, 'approve');

  /**
   * @method approveHoliday
   * @param {string} id
   * @param {string} reviewerNotes
   * @return {Promise<*>}
   */
  rejectHoliday = (id, reviewerNotes) => this.update(id, {
      status: 'rejected',
      reviewer_notes: reviewerNotes,
  }, 'reject');

  /**
   * @method myAllowance
   * @return {Promise<*>}
   */
  myAllowance = () => this.get('holidays/allowance');

  /**
   * @method warning
   * @param {string} from
   * @param {string|null} to
   * @param {string|null} id
   * @return {Promise<*>}
   */
  warning = (from, to = null, id = null) => this.get(`holidays/warning`, {
      from, to, id
  });
}

export default new Holiday();
